import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import './FetalDevelopmentVideo.css';
import * as actions from '../Actions';
import Right from '../../right/Right';
import Service from '../../service/Service';
import ShareIcon from '../common/ShareIcon';
import withContext from "../../../withContext";
const service = new Service();

class FetalDevelopmentVideo extends Component {
    constructor(props) {
        super(props);
        let window_width = 1024;
        this.state = {
            window_width: window_width,
            cFlag: false,
            vid: '',
            image:"https://cdn.fcglcdn.com/brainbees/apps/image/fetal_developmentImage_week1.jpg"
        }
    }
    componentDidMount() {
        if (navigator.onLine) {
            document.addEventListener("click", actions.domClick);
            if (window.innerWidth > 767) {
                this.setState({ vid: document.querySelector("#videodesk") });
                document.getElementById('videomob').remove();
            } else {
                this.setState({ vid: document.querySelector("#videomob") });
                document.getElementById('videodesk').remove();
            }
            this.setState({window_width : window.innerWidth});
        } else {
            service.hideLoader();
            service.showAlert("Please Check Internet Connection!!!");
            return false;
        }
    }

    componentWillUnmount() {
        document.removeEventListener("click", actions.domClick);
    }

    playNow() {
        if (navigator.onLine) {
            if (!this.state.cFlag) {
                document.querySelector('.pause').style.display = 'none';
                document.querySelector('.play').style.display = 'block';
                document.querySelector("#active-bar").classList.add('changed');
                this.state.cFlag = true;
                this.state.vid.play();
            } else {
                document.querySelector('.play').style.display = 'none';
                document.querySelector('.pause').style.display = 'block';
                this.state.vid.pause();
                this.state.cFlag = false
            }
        } else {
            service.hideLoader();
            service.showAlert("Please Check Internet Connection!!!");
            return false;
        }
    }

    playVideo(e) {
        if (navigator.onLine) {
            let percentage = (this.state.vid.currentTime / this.state.vid.duration) * 100;
            if (this.state.vid && document.querySelector("#custom-seekbar") && document.querySelector(".custom-timer")) {
                document.querySelector('#custom-seekbar #active-bar').style.width = percentage + '%';
                document.querySelector(".custom-timer").innerText = (service.secondsToMS(this.state.vid.currentTime))
            }
            if (this.state.vid.currentTime === this.state.vid.duration) {
                document.querySelector('.play').style.display = 'none';
                document.querySelector('.pause').style.display = 'block';
                document.querySelector("#active-bar").classList.remove('changed');
                this.state.cFlag = undefined;
            }
        } else {
            service.hideLoader();
            service.showAlert("Please Check Internet Connection!!!");
            return false;
        }
    }

    seekbar(e) {
        if (navigator.onLine) {
            let left = (e.pageX - e.target.getBoundingClientRect().left);
            let totalWidth = document.querySelector("#custom-seekbar").offsetWidth;
            let percentage = (left / totalWidth);
            let vidTime = this.state.vid.duration * percentage;
            if (isFinite(vidTime)) {
                this.state.vid.currentTime = vidTime;
                document.querySelector('.custom-timer').innerText = service.secondsToMS(this.state.vid.currentTime);
            }
        } else {
            service.hideLoader();
            service.showAlert("Please Check Internet Connection!!!");
            return false;
        }
    }
    shareIcon(id) {
        if (document.querySelector('.sharing-options').style.display != "block") {
            document.querySelector('.sharing-options').style.display = "block";
        } else {
            document.querySelector('.sharing-options').style.display = "none";
        }
        if (window.innerWidth < 767) {
            document.getElementsByClassName('share-overlay')[0].style.display = 'block';
        }
    }
    shareTemplate(id,shareoption,imageUrl){
        // console.log("shareTemplate====>",imageUrl);
        if (global.ftk) {
            // console.log("non login");
            if (shareoption == "facebook" || shareoption == "whatsapp") {
                document.querySelector("meta[property='og\\:description']").content = "See how your baby is growing and developing week by week in our Fetal Development video, and find out how your body will feel as your pregnancy progresses.";
                document.querySelector("meta[property='og\\:image']").content = imageUrl;

            } else if (shareoption == "twitter" || shareoption == "pintrest") {
                document.querySelector("meta[property='twitter\\:description']").content = "See how your baby is growing and developing week by week in our Fetal Development video, and find out how your body will feel as your pregnancy progresses.";
                document.querySelector("meta[property='twitter\\:image']").content = imageUrl;
                document.querySelector("meta[property='twitter\\:title']").content = "PARENTING.FIRSTCRY.COM";
            }
            actions.shareArticle(shareoption, global.currentURL);
        } else {
            // console.log("non login========>1");
            service.showAlert("Please Login");
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;
            return false;
        }   
    }
    render() {
        var windowWidth = this.state.window_width;

        return (
            <main className="fetal-video-tool main-container">
                <Helmet
                    title="Fetal Development Video (Week 1 to Week 40) - FirstCry Parenting"
                    meta={[
                        { "name": "description", "content": "This fetal development video will tell you in detail progress of pregnancy, how a baby develops in the mother's womb after conception - a journey from week 1 to week 40." },
                        { "name": "atdlayout", "content": "tools_sp" },
                        { "property": "og:locale", "content": "en_US" }, 
                        { "property": "og:type", "content": "website" }, 
                        { "property": "og:title", "content": "PARENTING.FIRSTCRY.COM" }, 
                        { "property": "og:description", "content": "See how your baby is growing and developing week by week in our Fetal Development video, and find out how your body will feel as your pregnancy progresses." }, 
                        { "property": "og:url", "content": global.currentURL }, 
                        { "property": "og:image", "content": this.state.image }, 
                        { "property": "twitter:image", "content": this.state.image }, 
                        { "property": "twitter:title", "content": "PARENTING.FIRSTCRY.COM" }, 
                        { "property": "twitter:description", "content": "See how your baby is growing and developing week by week in our Fetal Development video, and find out how your body will feel as your pregnancy progresses." }
                    ]}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a href={service.getRedirectUrl("/tools")} className="R11_9e">Tools</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Fetal Development Video</span>
                    </div>
                   
                </div>

                <div className="fetalvideo-head">
                     {
                        (windowWidth < 767) ?
                        (<div className="mobile_listing">
                            <a href={service.getRedirectUrl(`/tools`)} title=""><span className="icon" data-icon-font="s"></span></a>
                            {global.ftk ?
                            <h1 className="M15_pink" id="skipToH1" tabIndex={0}>Fetal Development Video For {global.userAry['userName']}</h1>
                            :
                            <h1 className="M15_pink" id="skipToH1" tabIndex={0}>Fetal Development Video</h1>
                            }
                        </div>) :
                        (<div className="mobile_listing">
                            {global.ftk ?
                            <h1 className="B24_00" id="skipToH1" tabIndex={0}>Fetal Development Video For  {global.userAry['userName']}</h1>
                            :
                            <h1 className="B24_00" id="skipToH1" tabIndex={0}>Fetal Development Video</h1>
                            }
                        </div>)
                    } 
                </div>
                <div className="sub-container left">
                    <div className="data-container left">
                        <div className="fetus_video_container">
                            <div className="video_container">
                                <span className="clickhere" onClick={() => { this.playNow() }}>
                                    <span className="icon pause" data-icon-font="&#xe03e;"></span>
                                    <span className="icon play" data-icon-font="&#xe03d;"></span>
                                </span>
                                <span className="custom-timer">00:00</span>
                                <div id="custom-seekbar" onClick={(e) => { this.seekbar(e) }}>
                                    <span id="active-bar"></span>
                                </div>
                                <div className="video_dynamic">
                                    <video preload="yes" id="videomob" className="mobileVideo" width="100%" poster="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/mobweek122.jpg" onTimeUpdate={(e) => { this.playVideo(e) }} playsInline>
                                        <source src="https://cdn.cdnparenting.com/brainbees/apps/demo/parenting_mobilefetal-crop.mp4" type="video/mp4" />
                                        <source src="https://cdn.cdnparenting.com/articles/wp-content/uploads/2019/videos/mobilefetal-crop.ogv" type="video/ogv" />
                                        <source src="https://cdn.cdnparenting.com/articles/wp-content/uploads/2019/videos/mobilefetal-crop.wmv" type="video/wmv" />
                                        <source src="https://cdn.cdnparenting.com/brainbees/apps/demo/parenting_mobilefetal-crop.webm" type="video/webm" />
                                    </video>
                                    <video preload="yes" id="videodesk" className="desktopVideo" poster="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/mobweek122.jpg" width="100%" onTimeUpdate={(e) => { this.playVideo(e) }}>
                                        <source src="https://cdn.cdnparenting.com/brainbees/apps/demo/parenting_desktopfetal.mp4" type="video/mp4" />
                                        <source src="https://cdn.cdnparenting.com/articles/wp-content/uploads/2019/videos/desktopfetal.ogv" type="video/ogv" />
                                        <source src="https://cdn.cdnparenting.com/articles/wp-content/uploads/2019/videos/desktopfetal.wmv" type="video/wmv" />
                                        <source src="https://cdn.cdnparenting.com/brainbees/apps/demo/parenting_mobilefetal-crop.webm" type="video/webm" />
                                    </video>                                                  
                                </div>
                            </div>
                            <ShareIcon eleRef={this} tool={'FDV'} />
                                <div className="share-overlay"></div>
                        </div>
                    </div>
                </div>
                <Right url={this.props.location.pathname} /> 
            </main>
        )
    }
}

export default withContext(FetalDevelopmentVideo);
